import { _ } from "../../../polyglot/polyglot.js";
import inputFieldWidget from "./inputFieldWidget.js";

/**
 * Password field with validator
 * See inputField for more options
 */
function passwordFieldWidget(spec, my) {
	my ||= {};
	spec ||= {};

	spec.type ||= "password";
	const showBar = spec.showBar === undefined ? true : spec.showBar;

	const that = inputFieldWidget(spec, my);

	const validateInputField = that.validate;

	that.validate = function (val) {
		const valid = validateInputField(val); // super
		if (showBar && valid) {
			validatePassword();
		}
		return valid;
	};

	function validatePassword() {
		my.displayHelp(renderPasswordBarOn);
	}

	function renderPasswordBarOn(html) {
		const password = my.readValue();
		const strength = strengthOfPassword(password);

		html.div(
			{ class: "progress no-margin password" },
			html.div({
				class: ["progress-bar", `progress-bar-${strength.label}`],
				role: "progressbar",
				"aria-valuemin": "0",
				"aria-valuemax": "100",
				"aria-valuenow": strength.value,
				style: `width: ${strength.value}%`,
			}),
		);

		html.div(
			{ class: ["password", "progress-comment", strength.label] },
			strength.comment,
		);
	}

	function strengthOfPassword(password) {
		if (password.length >= 8 && password.match(/[\dA-Za-z]+/)) {
			return {
				value: 100,
				label: "success",
				comment: _("Strong password!"),
			};
		} else if (password.length > 5 && password.match(/[\dA-Za-z]+/)) {
			return { value: 60, label: "warning", comment: _("Strong enough") };
		} else if (password.length >= 5) {
			return { value: 40, label: "warning", comment: _("Weak password") };
		} else if (password.length >= 3) {
			return { value: 25, label: "danger", comment: _("Weak password") };
		} else if (password.length > 0) {
			return {
				value: 5,
				label: "danger",
				comment: _("Very weak password"),
			};
		}
		return { value: 1, label: "danger", comment: _("Empty password") };
	}

	return that;
}

export default passwordFieldWidget;
